import React from 'react';
import styles from './FormField.module.scss';

interface CheckboxInlineProps {
  id: string;
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
}

export function CheckboxInline({ id, label, checked, onChange }: CheckboxInlineProps) {
  return (
    <div className={styles.checkboxInline}>
      <input type="checkbox" id={id} checked={checked} onChange={(e) => onChange(e.target.checked)} />
      <label htmlFor={id}>{label}</label>
    </div>
  );
}
